import React from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

function Header({text}) {

    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <Box sx={{ 
                width: '100%', 
                height: { xs: 50, md: 120 }, 
                backgroundColor: '#E9ECEF',
                alignContent: 'center' 
            }}>
            <Typography 
                variant={isMobile ? 'body' : 'h4'}
                textAlign="center" 
                sx={{ 
                    fontWeight: 'bold', 
                    letterSpacing: '5px' 
                }}>
                {text.toUpperCase()}
            </Typography>
        </Box>
    );
}

export default Header;